/**
 * The list of supported meeting features to enable/disable through jwt.
 */
export const MEET_FEATURES = [
    'branding',
    'calendar',
    'callstats',
    'livestreaming',
    'lobby',
    'moderation',
    'outbound-call',
    'recording',
    'room',
    'screen-sharing',
    'sip-outbound-call',
    'transcription'
];
